import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormModel } from 'projects/assist/src/app/_shared/form/form-models/form-model';
import { Login } from '../models/user';

export class LoginFormModel extends FormModel<Login> {
  constructor(readonly fb: FormBuilder = new FormBuilder()) {
    super(
      {} as Login,
      fb.group({
        Username: ['', Validators.required],
        Password: ['', Validators.required],
        Code: [''],
        Thrust: [''],
      }).controls
    );
  }

  readonly Username = this.get('Username') as FormControl;
  readonly Password = this.get('Password') as FormControl;
  readonly Code = this.get('Code') as FormControl;
  readonly Thrust = this.get('Thrust') as FormControl;
}
